// extracted by mini-css-extract-plugin
export default {"cls1":"CreateSocialItem-cls1___299d8d7a2289dbccdc2","cls2":"CreateSocialItem-cls2___e594e692440be24102d CreateSocialItem-cls1___299d8d7a2289dbccdc2"};